import { ElNotification } from 'element-plus';
import i18n from '../i18n';

const t = (message) => {
    return i18n.global.t(message);
};

const replaceInMessage = (search, replace, subject) => {
    if (typeof replace === 'number') {
        // Message containing single variable eg. Invalid [x], [x] is a required field
        return subject.replace(new RegExp(search.replace('[', '\\['), 'g'), replace);
    }

    if (typeof replace === 'string') {
        // Message containing single variable eg. Invalid [x], [x] is a required field
        return subject.replace(new RegExp(search.replace('[', '\\['), 'g'), t(replace));
    }

    // Message containing multiple variables eg. Please specify a [x] that is at most [y] characters
    let text = subject;
    search.forEach((x, index) => {
        text = replaceInMessage(x, replace[index], text);
    });
    return text;
};

const formatMessage = (message) => {
    // String message
    if (typeof message === 'string') {
        return t(message);
    }

    return replaceInMessage(message[0], message[1], t(message[2]));
};

// show error message for unsuccessful action (eg. save/ delete)
const showErrorMessage = (text) => {
    ElNotification({ title: t('Error'), message: text, type: 'error', offset: 85 });
};

// show update successful message for action (eg. save/ delete) success
const showSuccessMessage = (text) => {
    ElNotification({ title: t('Success'), message: text, type: 'success', offset: 85 });
};

const showValidationMessage = (text) => {
    alert(formatMessage(text));
};

export { formatMessage, showErrorMessage, showSuccessMessage, showValidationMessage };
